import { expandToBackendURL } from '@plone/volto/helpers';
export const POST_WORKFLOW = 'POST_BOOKING_WORKFLOW';
export const RESET_BOOKING_WORKFLOW = 'RESET_BOOKING_WORKFLOW';
export const GET_WORKFLOW_HISTORY = 'GET_WORKFLOW_HISTORY';

/**
 * post workflow
 * @function workflow
 */
export function workflow(bookingPath, action, comment) {
  const path = expandToBackendURL(bookingPath) + '/@workflow/' + action;

  return {
    type: POST_WORKFLOW,
    request: {
      op: 'post',
      path: path,
      data: { comment },
    },
  };
}

export function workflowHistory(bookingPath) {
  const path = expandToBackendURL(bookingPath) + '/@history';

  return {
    type: GET_WORKFLOW_HISTORY,
    subrequest: bookingPath,
    request: {
      op: 'get',
      path: path,
    },
  };
}

export function resetWorkflow() {
  return {
    type: RESET_BOOKING_WORKFLOW,
  };
}
